import { slugify } from "../../utils/slugify.js";
import { Locale, type LocalizedString } from "../Locale.js";
import type { SolutionContent } from "../solutions/SolutionContent.js";
import { solutionGroupNameMap } from "../names/solutionGroupNameMap.js";
import { solutionsPathMap } from "./solutionsPathMap.js";

export function getSolutionDetailPath(solution: SolutionContent): LocalizedString {
	return Object.values(Locale).reduce(
		(acc: LocalizedString, locale: Locale) => ({
			...acc,
			[locale]: `${solutionsPathMap[locale]}/${slugify(solutionGroupNameMap[solution.group][locale])}/${slugify(solution.name[locale])}`,
		}),
		{} as LocalizedString,
	);
}
